import React from 'react';
import { Tag } from 'antd';
import type { StatusTone } from '../../shared/utils/match-status';

// Semantic status pill; color is always paired with the visible label.
export default function StatusTag({ tone, children }: { tone: StatusTone; children: React.ReactNode }) {
  return <Tag className={`tn-status tn-status--${tone}`}>{children}</Tag>;
}
